import styled, { css } from "styled-components"
import { Button } from "@puregym/ui"
import { ButtonLink } from "src/components/buttons/buttonLink"

export const largeButtonCss = css`
  justify-content: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.baseSpacing};
  font-size: ${({ theme }) => theme.fontSizes.large};
`

export const LargeButton = styled(Button)`
  ${largeButtonCss}
`

export const LargeButtonLink = styled(ButtonLink)`
  ${largeButtonCss}
`
